import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../forms/form-components/expansion-panel/expansion-panel';
import { CommunicationsDetailsView } from './communication-details';

export const CommunicationsView = () => {
    return (
        <ExpansionPanel name="Communication Details">
            <CommunicationsDetailsView />
        </ExpansionPanel>
    );
};
